import { Routes, Route, Navigate, useLocation, type Location } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import AuthGuard from '@/components/AuthGuard'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Inventories from '@/pages/Inventories'
import InventoryDetails from '@/pages/InventoryDetails'
import Sources from '@/pages/Sources'
import Assets from '@/pages/Assets'
import AssetDetails from '@/pages/AssetDetails'
import Policies from '@/pages/Policies'
import PolicyDetail from '@/pages/PolicyDetail'
import Waivers from '@/pages/Waivers'
import Alerts from '@/pages/Alerts'
import Graph from '@/pages/Graph'
import Connectors from '@/pages/Connectors'
import Reports from '@/pages/Reports'
import Calibration from '@/pages/Calibration'
import Settings from '@/pages/Settings'
import Standards from '@/pages/Standards'

function App() {
  const location = useLocation()
  // When a link opens an asset "on top" (passes backgroundLocation), keep the previous
  // page mounted underneath and render the asset detail as an overlay — a nav stack, so
  // Back returns to the exact previous page + scroll with no reload.
  const state = location.state as { backgroundLocation?: Location } | null
  const background = state?.backgroundLocation

  return (
    <>
      <Routes location={background || location}>
        <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        {/* Default landing = Dashboard */}
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Navigate to="/" replace />} />
        <Route path="inventories" element={<Inventories />} />
        <Route path="inventories/:id" element={<InventoryDetails />} />
        <Route path="sources" element={<Sources />} />
        <Route path="assets" element={<Assets />} />
        <Route path="assets/:id" element={<AssetDetails />} />
        <Route path="standards" element={<Standards />} />
        <Route path="policies" element={<Policies />} />
        <Route path="policies/:id" element={<PolicyDetail />} />
        <Route path="waivers" element={<Waivers />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="graph" element={<Graph />} />
        <Route path="reports" element={<Reports />} />
        <Route path="connectors" element={<Connectors />} />
        <Route path="calibration" element={<Calibration />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>

      {/* Asset detail as an overlay above the kept-alive background page. Rendered as a
          full Layout (own header + sidebar + main) so it looks like a real asset page,
          while the previous page stays mounted underneath for an instant Back. */}
      {background && (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-background-light dark:bg-background-dark">
          <Routes>
            <Route element={<Layout />}>
              <Route path="/assets/:id" element={<AssetDetails />} />
            </Route>
          </Routes>
        </div>
      )}
    </>
  )
}

export default App
